// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;
var interval;
var dashboardInitialized = false;
var statusWidgetsLoading = false;
var statusWidgetRequests = [];
var statusWidgetBatchId = 0;

function initDashboard(force) {
  // Check if we're on the dashboard
  var isDashboard = $('#job-stats').length > 0 || $('h2:contains("Dashboard")').length > 0;
  
  if (isDashboard) {
    // Prevent multiple simultaneous initializations unless forced (e.g., Turbo Frame load)
    if (dashboardInitialized && !force) {
      return;
    }
    dashboardInitialized = true;
    
    // Clear any existing interval
    if (interval) {
      clearInterval(interval);
    }
    
    display_main_widgets();
    display_charts();
    display_status_widgets();
    
    // timer to update dashboard widgets
    interval = setInterval(refresh_widgets, 180000); // 3 minute refresh for main widget data
  } else {
    // Reset flag when leaving dashboard
    dashboardInitialized = false;
  }
}

// Expose globally
window.initDashboard = initDashboard;

$(document).on('turbo:frame-load turbo:load', function(event) {
  // Force re-initialization on Turbo Frame loads to ensure counters update
  initDashboard(true);
});

$(document).ready(function() {
  initDashboard();
});

// Also listen specifically for turbo-frame loads
$(document).on('turbo:frame-load', 'turbo-frame#main-body', function() {
  // Force re-initialization when main-body frame loads
  // Use setTimeout to ensure DOM is ready
  setTimeout(function() {
    initDashboard(true);
  }, 100);
});

function refresh_widgets() {
  if( $('turbo-frame#main-body.section-dashboard-show').html() ) {
    display_main_widgets();
  } else {
    clearInterval(interval);
  }
}

function display_main_widgets() {
  var widgets = ['open_jobs', 'recent_jobs', 'rush_jobs', 'need_to_invoice_jobs'];
  
  $(widgets).each(function(index, value) {
    get_work_count(value);
  })
}


function display_status_widgets() {
  var widgets = ['art', 'prepress', 'proofing', 'ready-to-print', 'press', 'holding', 'outside', 'mail-house', 'bindery', 'ready-to-deliver'];
  
  // Only proceed if the container exists
  if ($('#mini-job-stats').length === 0) {
    return;
  }
  
  // Cancel any pending requests to prevent duplicates
  if (statusWidgetsLoading) {
    statusWidgetRequests.forEach(function(xhr) {
      if (xhr && xhr.abort) {
        xhr.abort();
      }
    });
    statusWidgetRequests = [];
  }
  
  // Clear existing widgets to prevent duplicates
  $('#mini-job-stats').empty();
  
  statusWidgetsLoading = true;
  statusWidgetRequests = [];
  statusWidgetBatchId++; // Increment batch ID for this set of requests
  var currentBatchId = statusWidgetBatchId;
  
  $(widgets).each(function(index, value) {
    var xhr = $.get({
      url: '/dashboard/count_status/',
      data: {
        widget: value
      },
      success: function(data) {
        // Only process if this is still the current batch (prevent race conditions)
        if (currentBatchId !== statusWidgetBatchId) {
          return;
        }
        if (data && typeof data === 'object') {
          display_status_widget(data);
        }
        // Remove this request from the array when it completes
        var reqIndex = statusWidgetRequests.indexOf(xhr);
        if (reqIndex > -1) {
          statusWidgetRequests.splice(reqIndex, 1);
        }
        // If all requests are complete, reset the loading flag
        if (statusWidgetRequests.length === 0) {
          statusWidgetsLoading = false;
        }
      },
      error: function(xhr, status, error) {
        //console.error('Error loading status widget for', value, ':', error);
        // Remove this request from the array when it errors
        var reqIndex = statusWidgetRequests.indexOf(xhr);
        if (reqIndex > -1) {
          statusWidgetRequests.splice(reqIndex, 1);
        }
        // If all requests are complete, reset the loading flag
        if (statusWidgetRequests.length === 0) {
          statusWidgetsLoading = false;
        }
      }
    });
    statusWidgetRequests.push(xhr);
  })
}

function display_status_widget(widget) {
  if (!widget || !widget.name) {
    console.error('Invalid widget data:', widget);
    return;
  }
  
  var widgetClass = widget.name.replace(/ /g, '-');
  
  // Check if widget already exists to prevent duplicates
  var existingWidget = $('#mini-job-stats').find('.' + widgetClass + '-job');
  if (existingWidget.length > 0) {
    // Update existing widget instead of creating duplicate
    existingWidget.find('dt').text(widget.name);
    existingWidget.find('dd a').text(widget.count || 0);
    existingWidget.css({
      'background-color': widget.background_color || '#ffffff',
      'color': widget.color || '#333333'
    });
    existingWidget.find('dd a').css('color', widget.color || '#333333');
    return;
  }
  
  var html = status_widget_html();
  var statusUrl = widget.name.replace(/ /g, '-');
  
  html = html.replace('WIDGET', widgetClass);
  html = html.replace('BACKGROUND-COLOR', widget.background_color || '#ffffff');
  html = html.replace('COLOR', widget.color || '#333333');
  html = html.replace('STATUS_NAME', widget.name);
  html = html.replace('STATUS_COUNT', widget.count || 0);
  html = html.replace('JOBS_STATUS_URL', '/jobs?status=' + statusUrl);
  
  $('#mini-job-stats').append(html);  
}

function status_widget_html() {
  var html = ''
  html += '<dl class="counter-display WIDGET-job small" style="background-color: BACKGROUND-COLOR; color: COLOR;">';
  html += '  <dt>STATUS_NAME</dt>';
  html += '  <dd><a href="JOBS_STATUS_URL" style="color: COLOR;" target="main-body">STATUS_COUNT</a></dd>';
  html += '</dl>';
  return html;
}


function get_work_count(countee) {
  $.get({
    url: '/works/count_work', 
    data: {
      countee: countee
    },
    success: function(data) {
      $('dl[data-countee="' + countee + '"]').attr('data-count', data);
      $('dl[data-countee="' + countee + '"] dd a').html(data);
    }
  })
}

function display_charts() {
  // Wait for Chart.js to be available (it might load after this module)
  var attempts = 0;
  var maxAttempts = 10;
  
  function tryDisplayCharts() {
    attempts++;
    
    // Check if Chart.js is available
    if (typeof Chart === 'undefined' || typeof window.Chart === 'undefined') {
      if (attempts < maxAttempts) {
        setTimeout(tryDisplayCharts, 100);
      } else {
        console.error('Chart.js is not available after waiting. Charts cannot be displayed.');
      }
      return;
    }
    
    // Check if chart elements exist
    if ($('#job_starts_chart').length === 0 && $('#vendors_chart').length === 0) {
      console.warn('Chart elements not found on page');
      return;
    }
    
    // Use window.Chart if Chart is not directly available
    var ChartLib = window.Chart || Chart;
    
    // Load job chart if element exists
    if ($('#job_starts_chart').length > 0) {
      $.get({
        url: '/dashboard/job_chart/', 
        success: function(data) {
          if (data) {
            add_job_chart(data);
          }
        },
        error: function(xhr, status, error) {
          console.error('Error loading job chart:', error);
        }
      });
    }
    
    // Load vendor chart if element exists
    if ($('#vendors_chart').length > 0) {
      $.get({
        url: '/dashboard/vendor_chart/',
        success: function(data) {
          if (data) {
            add_vendor_chart(data);
          }
        },
        error: function(xhr, status, error) {
          console.error('Error loading vendor chart:', error);
        }
      });
    }
  }
  
  tryDisplayCharts();
}

function add_job_chart(chart_data) {
  var ctxEl = $('#job_starts_chart');
  
  // Check if canvas element exists and Chart.js is available
  var ChartLib = window.Chart || Chart;
  if (ctxEl.length === 0 || typeof ChartLib === 'undefined') {
    console.error('Cannot create job chart: element not found or Chart.js not available');
    return;
  }
  
  // Destroy existing chart if it exists
  if (ctxEl.data('chart')) {
    ctxEl.data('chart').destroy();
  }
  
  var ctx = ctxEl[0].getContext('2d');
  var ChartLib = window.Chart || Chart;
  var chart = new ChartLib(ctx, {
    type: 'bar',
    options: {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        }
      }, 
      scales: {
        x: {
          display: false,
          grid: { display: false },
          ticks: { display: false }
        },
        y: {
          display: false,
          grid: { display: false },
          ticks: { display: false }
        }
      }
    },
    data: {
      labels: chart_data.job_list_of_last_thirty_days || [],
      datasets: [{
        type: 'bar',
        label: 'Jobs',
        data: chart_data.job_last_thirty_days_of_starts || [],
        lineTension: 0.4,
        backgroundColor: 'rgba(58, 219, 118, 0.8)'
      },{
        type: 'line',
        label: 'Average',
        data: chart_data.job_last_thrity_days_of_averages || [],
        lineTension: 0.4,
        backgroundColor: 'rgb(23, 121, 186)',
        borderColor: 'rgb(23, 121, 186)',
        borderWidth: 2,
        fill: false
      }]
    }
  });
  
  // Store chart reference for cleanup
  ctxEl.data('chart', chart);
}

function add_vendor_chart(chart_data) {
  var vendorChartEl = $('#vendors_chart');
  
  // Check if canvas element exists and Chart.js is available
  var ChartLib = window.Chart || Chart;
  if (vendorChartEl.length === 0 || typeof ChartLib === 'undefined') {
    console.error('Cannot create vendor chart: element not found or Chart.js not available');
    return;
  }
  
  // Destroy existing chart if it exists
  if (vendorChartEl.data('chart')) {
    vendorChartEl.data('chart').destroy();
  }
  
  var ctx = vendorChartEl[0].getContext('2d');
  var ChartLib = window.Chart || Chart;
  var vendorChart = new ChartLib(ctx, {
    type: 'doughnut',
    options: {
      aspectRatio: 1.2,
      plugins: {
        legend: {
          display: false
        }
      },
      cutout: '50%'
    },
    data: {
      labels: chart_data.job_list_of_open_job_vendors || [],
      datasets: [{
        label: 'Vendors',
        data: chart_data.job_open_job_vendor_count || [],
        backgroundColor: chart_data.job_vendor_colors || []
      }]
    }
  });
  
  // Store chart reference for cleanup
  vendorChartEl.data('chart', vendorChart);
}


